// patient-measure-details.component.ts
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule, MatTable } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardMeasurePatient } from '@models/dashboard-measure-patient.model';
import { AddTicketModalComponent } from '@components/modals/add-ticket-modal/add-ticket-modal.component';



@Component({
  selector: 'app-patient-measure-details',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatMenuModule,
    FormsModule
  ],
  templateUrl: './patient-measure-details.component.html',
  styleUrls: ['./patient-measure-details.component.css']
})
export class PatientMeasureDetailsComponent implements OnInit, AfterViewInit {
  @Input() measureId: string = '';
  @Input() patientMeasures: DashboardMeasurePatient[] = [];
  
  @Output() close = new EventEmitter<void>();
  
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<DashboardMeasurePatient>;
  
  displayedColumns: string[] = [

    'patientID',
    'providerName',
    'firstName',
    'lastName',
    'gender',
    'age',
    'encounterDate',
    'den',
    'denExcl',
    'num',
    'diagCode',
    'diagDesc',
    'procedure',
    'procedureDate',
    'medication',
    'medicationDate',
    'actions'
  ];
  
  // Use MatTableDataSource for built-in sorting, filtering, and pagination
  filteredPatients = new MatTableDataSource<DashboardMeasurePatient>([]);
  
  constructor(private dialog: MatDialog) { }
  
  ngOnInit(): void {
    // Filter patients based on measureId
    const patients = this.patientMeasures;
    
    // Set the filtered data to the data source
    this.filteredPatients.data = patients;
  }
  
  ngAfterViewInit() {
    // Connect the paginator to the data source
    this.filteredPatients.paginator = this.paginator;
    
    // Connect the sort to the data source
    this.filteredPatients.sort = this.sort;
  }
  
  onClose(): void {
    this.close.emit();
  }
  
  createTicket(patient: DashboardMeasurePatient): void {

      const dialogRef = this.dialog.open(AddTicketModalComponent, {
        width: '400px',
      });
  
      dialogRef.afterClosed().subscribe(result => {

      });
    
  }
  
 
  
  openActionMenu(patient: DashboardMeasurePatient): void {

  }

  validatePatient(patient: DashboardMeasurePatient): void {
    patient.validated = true;
  }

  
}